export enum RoutesEnum {
  Home = '/',
  LiveCasino = '/live-casino',
  LiveCasinoAll = '/live-casino/all',
  Sports = '/the-thao',
  LobbyGame = '/tro-choi',
  LobbyGameAll = '/tro-choi/all',
  Login = '/login',
  Register = '/register',
  Bong88 = '/bong88',
  Slots = '/tro-choi/slots',
  OtherGames = '/tro-choi/other',
  Fishing = '/tro-choi/ban-ca',
  NumberGames = '/tro-choi/quay-so',
  Lode = '/tro-choi/lode',
  InstantGames = '/tro-choi/instant',
  GameBai = '/tro-choi/game-bai',
  RecentPlayedGames = '/choi-gan-day',
  FavoriteGames = '/yeu-thich',
  About = '/ve-chung-toi',
  PrivacyPolicy = '/chinh-sach-bao-mat',
  TermsAndConditions = '/dieu-khoan-dieu-kien',
  LegalBetting = '/cuoc-hop-phap',
  ContactUs = '/lien-he',
  InstructRegister = '/huong-dan-dang-ky-tai-khoan',
  News = '/tin-tuc',
  FootballNews = '/tin-tuc/nhan-dinh-bong-da',
  SoiKeo = '/tin-tuc/soi-keo-bong-da',
  TinNoiBat = '/tin-tuc/tin-noi-bat',
  TipFootball = '/tin-tuc/tip-bong-da',
  LodeOnline = '/tin-tuc/lo-de-online',
  Search = '/search',
  Transaction = '/transaction',
  TransactionWithdraw = '/transaction?tab=rut-tien',
  EventDrawingLots = '/su-kien-rut-tham',
  SlotTechplay = '/tro-choi/slots/techplay',
  Maintenance = '/maintenance',
  NotFound = '/404',
}

export enum DepositRouteEnum {
  Deposit = '/nap-tien',
  Fastpay = '/nap-tien/fastpay',
  Ewallet = '/nap-tien?method=ewallet',
  Banking = '/nap-tien/banking',
  PhoneCard = '/nap-tien?method=phone_card',
  Senpay = '/nap-tien/senpay',
  Crypto = '/nap-tien?method=crypto',
  QRPay = '/nap-tien?method=qrpay',
}

export enum WithdrawRouteEnum {
  Withdraw = '/rut-tien',
  WithdrawBank = '/rut-tien?method=banking',
  WithdrawPhoneCard = '/rut-tien?method=phone_card',
  WithdrawCrypto = '/rut-tien?method=crypto',
}

export enum CasinoRouteEnum {
  Evolution = '/live-casino/evolution',
  Ebet = '/live-casino/ebet',
  DGCasino = '/live-casino/dream-gaming',
  Vivogaming = '/live-casino/vivo-gaming',
  Ezugi = '/live-casino/ezugi',
  PragmaticPlay = '/live-casino/pragmatic',
  Hogaming = '/live-casino/hogaming',
  Go88 = '/live-casino/go88',
  Rikvip = '/live-casino/rikvip',
  B52 = '/live-casino/b52',
  Yeebet = '/live-casino/yeebet',
  Microgaming = '/live-casino/microgaming',
  Hitclub = '/live-casino/hitclub',
  Sunwin = '/live-casino/sunwin',
  Club789 = '/live-casino/789club',
}

export enum PromotionRouteEnum {
  Promotion = '/khuyen-mai',
  FirstDepositPromotion = '/khuyen-mai/thuong-nap-lan-dau',
  SecondDepositPromotion = '/khuyen-mai/thuong-nap-lan-hai',
  UnlimitedDepositPromotion = '/khuyen-mai/hoan-tra-vo-tan',
  SanSieuHutPromotion = '/khuyen-mai/khai-truong-hong-phat',
}

export enum AccountRouteEnum {
  Account = '/account',
  ResetPassword = '/reset-password',
  AccountInformation = '/account/information',
  TransferMoney = '/account/transfer-money',
  ChangePassword = '/account/password',
  Transaction = '/account/transaction-history',
  BetHistory = '/account/bet-history',
  PromotionRefund = '/account/refund',
  MyPromotion = '/account/my-promotion',
  UserBank = '/account/user-bank',
  TransactionCoin12 = '/transaction-coin12',
}

export enum GameCategoryEnum {
  Slots = 'slots',
  Lode = 'lode',
  Sports = 'sports',
  Casino = 'casino',
  LobbyGame = 'lobby-game',
}
export enum PromotionIdEnum {
  NOHU = 7,
}
